import { Helmet } from "react-helmet-async";

// Per-route meta. The static <head> in public/index.html is the crawler floor;
// these overrides apply once React renders (and to prerendered bots on deploy).
export function Seo({ title, description, noindex = false }) {
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta
        name="robots"
        content={noindex ? "noindex, nofollow" : "index, follow, max-image-preview:large, max-snippet:-1"}
      />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
    </Helmet>
  );
}
